import cn from 'classnames';
import { ReactNode, useEffect } from 'react';
import { ArrowIcon } from '../Icons';
import styles from './Modal.module.scss';

type ModalProps = {
  closeButton?: string;
  className?: string;
  children: ReactNode;
  active: boolean;
  fullScreen?: boolean;
  closeFn: () => void;
};

export function Modal({
  closeButton,
  active,
  closeFn,
  children,
  fullScreen,
  className,
}: ModalProps) {
  const wrapperClassName = cn(styles.wrapper, className);

  useEffect(() => {
    const body = document.querySelector('body');
    if (active && body) {
      body.classList.add('modal-opened');
    }
    if (!active && body) {
      body.classList.remove('modal-opened');
    }
  }, [active]);

  if (!active) return null;

  if (fullScreen) {
    return (
      <div className={wrapperClassName}>
        {closeButton && (
          <div className={styles.header}>
            <div className={styles.close} onClick={() => closeFn()}>
              <ArrowIcon width={24} height={24} color="#18232E" />
              <span className={styles.dark}>{closeButton}</span>
            </div>
            <img src="/svg/logo-dark.svg" alt="logo" className={styles.logo} />
          </div>
        )}
        {children}
      </div>
    );
  }

  return (
    <div className={wrapperClassName}>
      {closeButton && (
        <div className={styles.close} onClick={() => closeFn()}>
          <img loading="lazy" src="/svg/modal-close.svg" alt="close-button" />
          <span className={styles.light}>{closeButton}</span>
        </div>
      )}
      <div className={styles.blur} onClick={() => closeFn()} />
      {children}
    </div>
  );
}
